import { formatReportValue } from "@common/helpers/reports";
import { ReportPeriodWithLabel } from "@common/types/reports/types";
import { BaseCellProps } from "@components/spreadsheet/cells";
import { ColumnDef } from "@components/spreadsheet/types";
import {
    PLSpreadsheetRow,
    shouldHideExpandedRowValue,
} from "./profitLossActivationUtils";

export type AmountDrillDownHandler = (
    row: PLSpreadsheetRow,
    period: ReportPeriodWithLabel,
) => void;

interface BuildAmountCellFnParams {
    expandedIds: string[];
    onDrillDown?: AmountDrillDownHandler;
}

export const buildAmountCellFn =
    ({ expandedIds, onDrillDown }: BuildAmountCellFnParams) =>
    (period: ReportPeriodWithLabel): ColumnDef["cellFn"] =>
        function AmountCellRenderer({ value, row }: BaseCellProps) {
            const plRow: PLSpreadsheetRow = row;
            if (shouldHideExpandedRowValue(plRow, expandedIds)) {
                return null;
            }
            const numericValue = typeof value === "number" ? value : null;
            const canDrillDown =
                onDrillDown !== undefined &&
                numericValue != null &&
                numericValue !== 0 &&
                !period.comparisonDiff &&
                !period.ratioType;
            return (
                <span
                    style={{
                        display: "block",
                        width: "100%",
                        textAlign: "right",
                        fontVariantNumeric: "tabular-nums",
                        cursor: canDrillDown ? "pointer" : undefined,
                    }}
                    onDoubleClick={() => {
                        if (canDrillDown) {
                            onDrillDown(plRow, period);
                        }
                    }}
                >
                    {numericValue != null
                        ? formatReportValue(numericValue, {
                              comparisonDiff: period.comparisonDiff,
                              ratioType: period.ratioType,
                          })
                        : "-"}
                </span>
            );
        };
